import { getContentComponentForStepType } from "library/show/components/content"
import "./ManageContentPreview.css"

// Wraps content view w/ edit option

const ManageContentPreview = function ({ step, content }) {
  const ContentComponent = getContentComponentForStepType(step.assignment_type)

  return (
    <div className="ManageContent__Preview">
      <div className="ManageContent__PreviewBody">
        <ContentComponent content={content} step={step} />
      </div>
    </div>
  )
}

ManageContentPreview.displayName = "ManageContentPreview"
export default ManageContentPreview
